import { useCallback } from 'react';
import { useLoginMutation } from 'api/gameplay'; // Import your login mutation
import { getLoginPayload } from 'utils/commonFunctions';
import { LOGIN_TOKEN, LOGIN_TOKEN_NAME } from 'utils/constants';

const useLogin = () => {
  const [login, { isLoading, isError }] = useLoginMutation();
  const performLogin = useCallback(async () => {
    const payload = getLoginPayload();
    // const token = localStorage.getItem(LOGIN_TOKEN);

    try {
      // const data = await login({ payload, token }).unwrap();
      // const combinedData = { ...data?.data, token };
      // localStorage.setItem(LOGIN_TOKEN_NAME, JSON.stringify(combinedData));
      const data = await login({ payload }).unwrap();
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  }, [login]);

  return { performLogin, isLoading, isError };
};

export default useLogin;
